import { UserService } from 'src/app/services/user-service/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CarHistoryReportService } from 'src/app/services/car-history-report/car-history-report.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-car-history-report',
  templateUrl: './car-history-report.component.html',
  styleUrls: ['./car-history-report.component.scss']
})
export class CarHistoryReportComponent implements OnInit {
  public reportDetailsForm: UntypedFormGroup;
  public file: any;
  public allData: object | null = null;
  public loading: boolean = false;
  public isSubmitted: boolean = false;
  public mediaUrl = environment().base_path + 'storage/vehicle/history/';
  public env = environment().base_path + 'storage/vehicle/history/';
  constructor(
    public formbuilder: UntypedFormBuilder,
    private reportService: CarHistoryReportService,
    private sharedService: SharedService,
    public toastr: ToastrService,
    private _userService: UserService
  ) {
    this.reportDetailsForm = this.formbuilder.group({
      test_drive_video: [''],
      history_file: [''],
      history_comment: [''],
      computer_report_file: [''],
      computer_report_comment: [''],
      vehicle_history_uuid: [''],
      vehicle_id: this.sharedService.getVehicleId
    });
  }

  get historyControls() {
    return this.reportDetailsForm.controls;
  }

  ngOnInit(): void {
    this.showCarReportHistory();
    this.getAllInfo();
  }

  selectedFile: string | Blob = '';
  getFile(ev: any) {
    if (ev.target.files.length) {
      this.selectedFile = ev.target.files[0];
    }
  }
  selectedComputerFile: string | Blob = '';
  getComputerFile(ev: any) {
    if (ev.target.files.length) {
      this.selectedComputerFile = ev.target.files[0];
    }
  }

  showCarReportHistory() {
    this.loading = true;
    const formData = {
      vehicle_id: this.sharedService.getVehicleId
    };
    this.reportService.getCarHistory(formData).subscribe(
      (res) => {
        this.allData = Array.isArray(res['data']) ? res['data'][0] : null;
        if (this.allData) {
          this.reportDetailsForm.get('history_comment').setValue(this.allData['history_comment']);
          this.reportDetailsForm
            .get('computer_report_comment')
            .setValue(this.allData['computer_report_comment']);
          this.reportDetailsForm
            .get('vehicle_history_uuid')
            .setValue(this.allData['vehicle_history_uuid']);
        }
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  getAllInfo() {
    const formData = {
      vehicle_id: this.sharedService.getVehicleId
    };
    this._userService.GetVinInfo(formData).subscribe((res: any) => {
      let data = res['data'];
      let vehicleDetails: Object = data['vehicle_details'];
      if (vehicleDetails?.['test_drive_video']) {
        this.reportDetailsForm.get('test_drive_video').setValue(vehicleDetails['test_drive_video']);
      }
    });
  }

  submitReport() {
    this.loading = true;
    this.isSubmitted = true;
    const formData = new FormData();
    Object.entries(this.reportDetailsForm.value).forEach(([key, value]: any) => {
      if (key === 'history_file' && this.selectedFile) {
        formData.append(key, this.selectedFile);
      } else if (key === 'computer_report_file' && this.selectedComputerFile) {
        formData.append(key, this.selectedComputerFile);
      } else {
        formData.append(key, value);
      }
    });
    this.reportService.addCarHistory(formData).subscribe(
      (res) => {
        if (res['success']) {
          location.reload();
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.loading = false;
      }
    );
  }

  deleteCarReportHistory(vehicleHistoryUuid: any) {
    this.loading = true;
    const formData = {
      vehicle_history_uuid: vehicleHistoryUuid
    };
    this.reportService.deleteCarHistory(formData).subscribe(
      (res) => {
        if (res['success']) {
          this.showCarReportHistory();
          this.toastr.success(res['data']);
          this.loading = false;
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.loading = false;
      }
    );
  }
}
